import ApiHelper from "./ApiHelper";

class AgentService {
  static async addAgent(data) {
    return ApiHelper.postAnonymous("/admin/agent/add", data);
  }

  static async editAgent(data) {
    return ApiHelper.postAnonymous("/admin/agent/edit", data);
  }

  static async getAllAgent(data) {
    return ApiHelper.postAnonymous("/admin/agent/get/all", data);
  }

  static async getAgentById(id) {
    return ApiHelper.getAnonymous(`/admin/agent/${id}`);
  }

  static async deleteAgentById(id) {
    return ApiHelper.deleteAnonymous(`/admin/agent/${id}`);
  }

  static async addAccount(data) {
    return ApiHelper.postAnonymous("/admin/agent/account/add", data);
  }

  static async editAccountById(data) {
    return ApiHelper.postAnonymous("/admin/agent/account/edit", data);
  }

  static async getAccountByAgentId(data) {
    return ApiHelper.postAnonymous("/admin/agent/account", data);
  }

  static async getDailyTransactionById(data) {
    return ApiHelper.postAnonymous(`/admin/account/daily/trasaction`, data);
  }

  static async getEntityListByAgentId(data) {
    return ApiHelper.postAnonymous("/admin/agent/entity/get/all", data);
  }
  static async editEntityListByAgentId(data) {
    return ApiHelper.postAnonymous("/admin/agent/entity/edit", data);
  }

  static async getCoinByAgentId(id) {
    return ApiHelper.getAnonymous(`/admin/crypto/accounts/${id}`);
  }

  // static async getAccountByAgentId(id, searchData, requestType) {
  //   if (searchData) {
  //     return ApiHelper.getAnonymous(`/admin/agent/account/${id}?search=${searchData}`);
  //   } else if (requestType) {
  //     return ApiHelper.getAnonymous(`/admin/agent/account/${id}?bankAccountFilter=${requestType}`);
  //   } else if (searchData && requestType) {
  //     return ApiHelper.getAnonymous(`/admin/agent/account/${id}?search=${searchData}?bankAccountFilter=${requestType}`);
  //   } else {
  //     return ApiHelper.getAnonymous(`/admin/agent/account/${id}`);
  //   }
  // }
}
export default AgentService;
